import { useState } from '#imports'
import { readonly } from 'vue'

import type { Product } from '@backmarket/nuxt-layer-recommendation/models/product'

export function useAdditionalProduct() {
  const additionalProduct = useState<Product | null>(
    'pp-additional-product',
    () => null,
  )

  function setAdditionalProduct(product: Product | null) {
    additionalProduct.value = product
  }

  function clearAdditionalProduct() {
    additionalProduct.value = null
  }

  return {
    setAdditionalProduct,
    clearAdditionalProduct,
    additionalProduct: readonly(additionalProduct),
  }
}
